import {
  Column,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Search,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import {
  TextBoxComponent,
  UploaderComponent,
} from '@syncfusion/ej2-react-inputs';
import React, { Component } from 'react';
import SourceAdaptorServices from '../../services/Dig/DigServices';
import './style.css';
import { getValue } from '@syncfusion/ej2-base';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import ReactDOM from 'react-dom';
import {
  ChipListComponent,
  ChipsDirective,
  ChipDirective,
  ButtonComponent,
} from '@syncfusion/ej2-react-buttons';
import { enableRipple } from '@syncfusion/ej2-base';
import Message from '../../utils/Message/Message';
import { all_information, loadingShow } from '../../App';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import { ThemeContext } from '../../context/theme.context';
import { AiFillContainer, AiFillRightCircle } from 'react-icons/ai';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import {
  DeleteContainer,
  getContainer,
} from '../../services/Dig/SyncContainer/SyncContainerServices';
import axios from 'axios';
import MyErrorBoundary from '../../components/ErrorBoundry';
import { DeleteTask, getTask } from '../../services/Dig/TaskManager/TaskManagerServices';
enableRipple(true);
interface IProps {
}
interface IState {
  SourceAdaptorData: any;
  AdaptorID: any;
  AdaptorName: any;
  ConnectionTypes: any;
  ConnectionActivatedDate: any;
  ConnectionDisabledDate: any;
  selectedStatus: any;
  selectedSourceSystem: any;
  selectedDatabase: any;
  selectedSourceSystemText: any;
  selectedDatabaseText: any;
  selectedStatusText: any;
  hideDialogDeleteSourceAdaptor: any;
  selectedEnabledText: any;
  isEdit: any;
  TaskData: any;
  SyncContainerData: any;
  SyncContainerTempData: any;
  DeletedTextModal: any;
}
class SourceAdaptor extends Component<IProps, IState> {
  private SourceAdaptorServices: SourceAdaptorServices;
  public editOptions: EditSettingsModel = {
    allowAdding: false,
    allowDeleting: false,
    allowEditing: false,
    allowEditOnDblClick: false,
    showConfirmDialog: false,
    showDeleteConfirmDialog: false,
  };
  public shipFormat: object = { type: 'date', format: 'dd/MM/yyyy' };
  public path: object = {
    removeUrl: 'https://ej2.syncfusion.com/services/api/uploadbox/Remove',
    saveUrl: 'https://ej2.syncfusion.com/services/api/uploadbox/Save',
  };
  public dowloadAgency = () => {
    return (
      <div>
        <ButtonComponent onClick={this.handleDowloadAgency}>
          Download Windows Service
        </ButtonComponent>
      </div>
    );
  };
  public toolbarOptionsSourceAdaptor = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
    {
      template: this.dowloadAgency,
    },
    'Search',
  ];
  private handleDowloadAgency = () => {
    // Setting various property values
    const element = document.createElement('a');

    element.href = 'https://app.uwork.com.au/static/media/uworkservice.rar';
    element.download = 'uworkservice.rar';
    element.click();
  };
  public toolbarOptionsContainer = [
    'Search',
    {
      text: 'Goto Container',
      tooltipText: 'goto',
      prefixIcon: 'e-transiction',
      id: 'goto',
    },
  ];
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  private buttonForDelete: ButtonPropsModel[];
  private gridSourceAdaptor: GridComponent;
  private gridSync: GridComponent;
  private chipsStatus: any;
  private chipsEnabled: any;
  private chipsSourceSystem: any;
  private chipsDatabase: any;
  static contextType = ThemeContext;
  private isRenderAllow: boolean = false;
  context!: React.ContextType<typeof ThemeContext>;
  private connectionType: DropDownListComponent;
  private source = axios.CancelToken.source();
  constructor(props: IProps) {
    super(props);
    this.state = {
      SourceAdaptorData: [],
      AdaptorID: 0,
      AdaptorName: '',
      ConnectionTypes: '',
      ConnectionActivatedDate: '',
      ConnectionDisabledDate: '',
      selectedStatus: 10,
      selectedSourceSystem: 10,
      selectedDatabase: 10,
      selectedSourceSystemText: '',
      selectedDatabaseText: '',
      selectedStatusText: '',
      hideDialogDeleteSourceAdaptor: false,
      selectedEnabledText: '',
      isEdit: false,
      TaskData: [],
      SyncContainerData: [],
      SyncContainerTempData: [],
      DeletedTextModal: '',
    };
    this.buttonForDelete = [
      {
        click: () => {
          this.deleteSourceAdaptor();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogDeleteSourceAdaptor: false });
        },
        buttonModel: {
          content: 'Cancel',
          isPrimary: false,
        },
      },
    ];

    this.SourceAdaptorServices = new SourceAdaptorServices();
    this.gridSourceAdaptor = new GridComponent(props);
    this.gridSync = new GridComponent(props);
    this.connectionType = new DropDownListComponent({});
  }
  getSourceAdaptor() {
    this.SourceAdaptorServices.getSourceAdaptors({org_id:all_information.company_id},this.source).then(
      (res: any) => {
        this.setState({ SourceAdaptorData: res.data });
      }
    );
  }
  getTask() {
    getTask({org_id:all_information.company_id},this.source).then((res: any) => {
      if (this.isRenderAllow) {
        this.setState({ TaskData: res.data });
      }
    });
  }
  getSyncContainer() {
    getContainer({org_id:all_information.company_id},this.source).then((res: any) => {
      this.setState({
        SyncContainerData: res.data,
        SyncContainerTempData: res.data,
      });
    });
  }
  componentDidMount() {
    // this.getSourceAdaptor();d
    this.isRenderAllow = true;
    this.getTask();
    // this.getSyncContainer();
    this.chipsDatabase.selectedChips = 10;
    this.chipsEnabled.selectedChips = 10;
    this.chipsSourceSystem.selectedChips = 10;
    this.chipsStatus.selectedChips = 10;
  }
  deleteSourceAdaptor() {
    const data = this.gridSourceAdaptor.getSelectedRecords() as any;
    const AdaptorID = data[0].AdaptorID;
    const findContainer = this.state.SyncContainerData.filter(
      (x: any) => x.adapter_id === AdaptorID
    );
    const findTask = this.state.TaskData.filter(
      (x: any) => x.adapter_id === AdaptorID
    );
    const obj = {
      AdaptorID: AdaptorID,
    };
    loadingShow(true);
    this.SourceAdaptorServices.DeleteSourceAdaptor(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Delete Successfully');
        this.getSourceAdaptor();
        this.setState({ hideDialogDeleteSourceAdaptor: false });
        this.cleanFields();
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
    findTask.map((task: any) => {
      loadingShow(true);
      const objTsk = {
        task_id: task.task_id,
      };
      DeleteTask(objTsk).then((e: any) => {
        loadingShow(false);
      });
    });
    findContainer.map((cont: any) => {
      loadingShow(true);
      const objCont = {
        container_id: cont.container_id,
      };
      DeleteContainer(objCont).then((e: any) => {
        loadingShow(false);
        this.getSourceAdaptor();
        this.getSyncContainer();
      });
    });
  }
  cellRender = (args: any) => {
    if (
      (args.column as Column).field === 'Status' ||
      (args.column as Column).field === 'Enabled'
    ) {
      const val = getValue((args.column as Column).field, args.data);
      let color = '';
      let textColor = '';
      let text = '';
      if (val === true) {
        color = '#339933';
        text = 'ACTIVE';
        textColor = 'white';
      } else if (val === false) {
        color = '#C90016';
        text = 'INACTIVE';
        textColor = 'white';
      }
      ReactDOM.render(
        <div
          style={{
            backgroundColor: color,
            padding: '5px',
            textAlign: 'center',
            color: textColor,
            borderRadius: '5px',
          }}
        >
          {text}
        </div>,
        args.cell as Element
      );
    }
    if ((args.column as Column).field === 'EnabledDate') {
      const val = getValue((args.column as Column).field, args.data);
      var num = parseInt(val.substring(6, 19));
      //var num = parseInt(str.replace(/[^09]/g, ""));
      var date = new Date(num);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const year = date.getFullYear();
      const result =
        (day < 10 ? '0' + day : day) +
        '/' +
        (month < 10 ? '0' + month : month) +
        '/' +
        year;
      ReactDOM.render(<div>{result}</div>, args.cell as Element);
    }
  };
  convertDate(val: any) {
    var num = parseInt(val.substring(6, 19));
    //var num = parseInt(str.replace(/[^09]/g, ""));
    var date = new Date(num);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    const result =
      (day < 10 ? '0' + day : day) +
      '/' +
      (month < 10 ? '0' + month : month) +
      '/' +
      year;
    return result;
  }
  rowselect(args: any) {
    let selRecord: any = args.data;
    let span1 = document.createElement('span');
    let span2 = document.createElement('span');
    let span3 = document.createElement('span');
    span1.innerHTML = 'Edit For ';
    span3.innerHTML = ' Source Adaptor';
    span2.innerHTML = selRecord.AdaptorName;
    span2.style.color = '#C90016';
    span2.style.textTransform = 'uppercase';
    $('.adaptorDynamicHeader').html('');
    $('.adaptorDynamicHeader').append(span1, span2, span3);
    const findSyncContainerData = this.state.SyncContainerData.filter(
      (x: any) => x.adapter_id === selRecord.AdaptorID
    );
    this.chipsStatus.selectedChips = selRecord.selectedStatus;
    this.chipsSourceSystem.selectedChips = selRecord.selectedSourceSystem;
    this.chipsDatabase.selectedChips = selRecord.selectedDatabase;
    this.chipsEnabled.selectedChips = selRecord.selectedEnabled;
    this.connectionType.text = selRecord.ConnectionTypes;
    this.connectionType.value = selRecord.ConnectionTypes_id;
    this.setState({
      SyncContainerTempData: findSyncContainerData,
      isEdit: true,
      AdaptorID: selRecord.AdaptorID,
      AdaptorName: selRecord.AdaptorName,
      selectedSourceSystemText: selRecord.AdaptorERP,
      selectedDatabaseText: selRecord.DatabaseName,
      selectedEnabledText:
        selRecord.selectedEnabled == 1 ? 'DISABLE' : 'ENABLE',
      selectedStatusText:
        selRecord.selectedStatus === 1 ? 'INACTIVE' : 'ACTIVE',
      ConnectionTypes: selRecord.ConnectionTypes,
      ConnectionActivatedDate: selRecord.ConnectionActivatedDate,
      ConnectionDisabledDate: selRecord.ConnectionDisabledDate,
    });
  }
  cleanFields = () => {
    this.chipsStatus.selectedChips = 10;
    this.chipsSourceSystem.selectedChips = 10;
    this.chipsDatabase.selectedChips = 10;
    this.chipsEnabled.selectedChips = 10;
    this.setState({
      AdaptorID: 0,
      AdaptorName: '',
      selectedSourceSystemText: '',
      selectedDatabaseText: '',
      selectedEnabledText: '',
      selectedStatusText: '',
      ConnectionTypes: '',
      ConnectionActivatedDate: '',
      ConnectionDisabledDate: '',
    });
  };
  AllSaveSourceAdaptor = () => {
    const adaptorName = this.state.AdaptorName;
    const selectedStatus = !this.chipsStatus.selectedChips;
    const selectedEnabled = !this.chipsEnabled.selectedChips;
    const connectionTypes = this.state.ConnectionTypes;
    const connectionActivateDate = $('#activateDate').val() as string;
    const connectionDisabledDate = $('#disabledDate').val() as string;
    const isEit = this.state.isEdit;

    const data = this.gridSourceAdaptor.getSelectedRecords() as any;
    const AdaptorID = data.length > 0 ? data[0]?.AdaptorID : -1;
    let message = '';
    if (adaptorName === '') {
      message = 'Can not be empty Adaptor Name';
      Message.error(message);
      return false;
    }
    if (this.chipsStatus.selectedChips === 10) {
      message = 'Can not be empty Status';
      Message.error(message);
      return false;
    }
    if (this.chipsEnabled.selectedChips === 10) {
      message = 'Can not be empty Enabled';
      Message.error(message);
      return false;
    }
    if (this.chipsDatabase.selectedChips === 10) {
      message = 'Can not be empty Database';
      Message.error(message);
      return false;
    }
    if (this.chipsSourceSystem.selectedChips === 10) {
      message = 'Can not be empty Source System';
      Message.error(message);
      return false;
    }
    if (connectionTypes === '') {
      message = 'Can not be empty Connection Types';
      Message.error(message);
      return false;
    }
    if (connectionActivateDate === '') {
      message = 'Can not be empty Connection Activated Date';
      Message.error(message);
      return false;
    }
    if (connectionDisabledDate === '') {
      message = 'Can not be empty Connection Disabled Date';
      Message.error(message);
      return false;
    }
    loadingShow(true);
    var aDateSplit = connectionActivateDate.split('/');
    var dDateSplit = connectionDisabledDate.split('/');
    var activateDateClean = new Date(
      parseInt(aDateSplit[2]),
      parseInt(aDateSplit[1]) - 1,
      parseInt(aDateSplit[0])
    ); // -1 because months are from 0 to 11
    var disabledDateClean = new Date(
      parseInt(dDateSplit[2]),
      parseInt(dDateSplit[1]) - 1,
      parseInt(dDateSplit[0])
    );
    const obj = {
      AdaptorName: adaptorName,
      AdaptorERP:
        this.chipsSourceSystem.chips[this.chipsSourceSystem.selectedChips].text,
      EnabledDate: new Date(),
      DatabaseName:
        this.chipsDatabase.chips[this.chipsDatabase.selectedChips].text,
      Status: selectedStatus,
      Enabled: selectedEnabled,
      ConnectionTypes: this.connectionType.text,
      ConnectionTypes_id: this.connectionType.value,
      ConnectionActivatedDate: new Date(activateDateClean),
      ConnectionDisabledDate: new Date(disabledDateClean),
      selectedStatus: this.chipsStatus.selectedChips,
      selectedSourceSystem: this.chipsSourceSystem.selectedChips,
      selectedDatabase: this.chipsDatabase.selectedChips,
      selectedEnabled: this.chipsEnabled.selectedChips,
      AdaptorID: AdaptorID,
    };
    //(obj);
    if (!isEit) {
      this.SourceAdaptorServices.AddSourceAdaptor(obj).then((res: any) => {
        this.getSourceAdaptor();
        loadingShow(false);
        Message.success('Successful');
        this.cleanFields();
      });
    } else {
      this.SourceAdaptorServices.EditSourceAdaptor(obj).then((res: any) => {
        this.getSourceAdaptor();
        loadingShow(false);
        Message.success('Successful');
        this.cleanFields();
      });
    }
  };

  selectedSourceSystemText(args: any) {
    this.setState({ selectedSourceSystemText: args.target.textContent });
  }
  selectedDatabaseText(args: any) {
    this.setState({ selectedDatabaseText: args.target.textContent });
  }
  selectedStatusText(args: any) {
    this.setState({ selectedStatusText: args.target.textContent });
  }
  selectedEnabledText(args: any) {
    this.setState({ selectedEnabledText: args.target.textContent });
  }

  toolbarClick(args: any) {
    if (args.item.id === 'add') {
      this.cleanFields();
      $('.adaptorDynamicHeader').html('Create a Source Adaptor');
      this.setState({ isEdit: false });
    }
    if (args.item.id === 'delete') {
      if (this.gridSourceAdaptor.getSelectedRecords().length !== 0) {
        const data = this.gridSourceAdaptor.getSelectedRecords() as any;
        const AdaptorID = data[0].AdaptorID;
        let msg = '';
        const findContainer = this.state.SyncContainerData.find(
          (x: any) => x.adapter_id === AdaptorID
        );
        const findTask = this.state.TaskData.find(
          (x: any) => x.adapter_id === AdaptorID
        );
        if (findContainer !== undefined || findTask !== undefined) {
          msg =
            'This Adapter is assigned to at least one task or container, do you still want to delete it?';
        }
        this.setState({
          hideDialogDeleteSourceAdaptor: true,
          DeletedTextModal: msg,
        });
      } else {
        Message.error('No records selected for deleted operation');
      }
    }
    if (args.item.id === 'goto') {
      if (this.gridSync.getSelectedRecords()) {
        if (this.gridSync.getSelectedRecords().length !== 0) {
          this.context.setChangeCurrentTab(true);
        }
      }
    }
  }
  gridOnFocus = () => {
    if (this.gridSourceAdaptor.getSelectedRecords().length === 0) {
      this.cleanFields();
      $('.adaptorDynamicHeader').html('Create a Source Adaptor');
      this.setState({ isEdit: false });
    }
  };
  load(args: any) {
    loadingShow(true);
  }
  componentWillUnmount() {
    this.isRenderAllow = false;
    if(this.source){
      
    }
  }
  created() {
    loadingShow(false);
    this.SourceAdaptorServices.getSourceAdaptors({org_id:all_information.company_id},this.source).then(
      (res: any) => {
        // this.setState({ SourceAdaptorData: res.data });
        if (this.gridSourceAdaptor) {
          this.gridSourceAdaptor.dataSource = res.data;
          this.gridSourceAdaptor.refresh();
        }
      }
    );
  }
  cellRenderSyncContainer = (args: any) => {
    if (
      (args.column as Column).field === 'status' ||
      (args.column as Column).field === 'enabled'
    ) {
      const val = getValue((args.column as Column).field, args.data);
      let color = '';
      let textColor = '';
      let text = '';
      if (val === true) {
        color = '#339933';
        text = 'ACTIVE';
        textColor = 'white';
      } else if (val === false) {
        color = '#C90016';
        text = 'INACTIVE';
        textColor = 'white';
      }
      ReactDOM.render(
        <div
          style={{
            backgroundColor: color,
            padding: '5px',
            textAlign: 'center',
            color: textColor,
            borderRadius: '5px',
          }}
        >
          {text}
        </div>,
        args.cell as Element
      );
    }
  };
  templateGoToContainer = () => {
    return (
      <div id='btn-tab-sourceadaptor'>
        <button
          className='btn btn-secondary'
          onClick={() => {
            try {
              loadingShow(true);
              setTimeout(() => {
                this.context.setChangeCurrentTab(true);
                loadingShow(false);
              }, 500);
            } catch (error) {
              alert(error);
            }
          }}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <AiFillContainer />
          Goto Containers
        </button>
      </div>
    );
  };
  gotoContainers(args: any) {
    this.context.setChangeCurrentTab(true, args.container_id);
  }
  gridSyncOncreated(args: any) {
    $('#btn-tab-sourceadaptor').css('display', 'block');
    getContainer({org_id:all_information.company_id},this.source).then((res: any) => {
      if (this.gridSync) {
        this.gridSync.dataSource = res.data;
        this.gridSync.refresh();
      }
    });
  }
  render() {
    return (
      <div className='sourceadaptor-content-section'>
        <div className='header-sourceadaptor-fixed'>
          <button
            style={{ marginRight: '5px', width: '90px', height: '40px' }}
            className='btn btn-primary p-3 rounded-xl'
            onClick={() => this.AllSaveSourceAdaptor()}
          >
            Save
          </button>
          <button
            style={{ width: '90px', height: '40px' }}
            className='btn btn-secondary p-3'
            onClick={() => {
              this.context.setChangeCurrentTab(true);
            }}
          >
            Cancel
          </button>
        </div>
        <div className='sourceadaptor-sub-content'>
          <div className='container-sourceadaptor'>
            <label style={{ marginBottom: '5px' }}>Source Adaptor</label>
            <GridComponent
              id='gridsourceadaptor'
              onClick={this.gridOnFocus}
              load={this.load.bind(this)}
              created={this.created.bind(this)}
              dataSource={this.state.SourceAdaptorData}
              editSettings={this.editOptions}
              toolbar={this.toolbarOptionsSourceAdaptor}
              ref={(g: GridComponent) => (this.gridSourceAdaptor = g)}
              height='25vh'
              filterSettings={this.FilterOptions}
              allowFiltering={true}
              allowPaging={true}
              pageSettings={this.pageOptions}
              showColumnMenu={true}
              allowResizing={true}
              allowGrouping={true}
              toolbarClick={this.toolbarClick.bind(this)}
              //actionBegin={this.begin.bind(this)}
              gridLines='Both'
              queryCellInfo={this.cellRender}
              rowSelected={this.rowselect.bind(this)}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field='AdaptorID'
                  headerText='Adaptor ID'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='AdaptorName'
                  headerText='Adaptor Name'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='AdaptorERP'
                  headerText='ERP'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='EnabledDate'
                  headerText='Enabled Date'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='DatabaseName'
                  headerText='Database'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='Status'
                  headerText='Status'
                  textAlign='Left'
                  width={70}
                />
                <ColumnDirective
                  field='Enabled'
                  headerText='Enabled'
                  textAlign='Left'
                  width={70}
                />
              </ColumnsDirective>
              <Inject
                services={[
                  Edit,
                  Toolbar,
                  Filter,
                  Page,
                  ColumnMenu,
                  Resize,
                  Search,
                  Group
                ]}
              />
            </GridComponent>
          </div>
          <div id='goLocationAdaptor' className='container-sourceadaptor'>
            <label
              style={{ marginBottom: '5px' }}
              className='adaptorDynamicHeader'
            >
              Adaptor Registration
            </label>

            <div className='adaptor-input'>
              <div className='responseAdaptorInput'>
                {this.state.AdaptorID > 0 ? (
                  <div>
                    <label>Adaptor ID</label>
                    <div className='adaptorID-text'>{this.state.AdaptorID}</div>
                  </div>
                ) : null}
                <div style={{ marginLeft: '30px' }}>
                  <label>Adaptor Name</label>
                  <div className='adaptorNme-text'>
                    <TextBoxComponent
                      id='sourceadaptorName'
                      placeholder='Adaptor Name'
                      value={this.state.AdaptorName}
                      onChange={(e: any) => {
                        this.setState({ AdaptorName: e.value });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='status-adaptor'>
                <div>
                  <span style={{ marginTop: '5px' }} className='col-md-3'>
                    Status
                  </span>
                  <div className='col-md-9'>
                    <ChipListComponent
                      id='chip-avatar-status'
                      ref={(g) => (this.chipsStatus = g)}
                      selection='Single'
                      onClick={this.selectedStatusText.bind(this)}
                    >
                      <ChipsDirective>
                        <ChipDirective
                          cssClass='chip-style-status-active'
                          text='ACTIVE'
                        ></ChipDirective>
                        <ChipDirective
                          cssClass='chip-style-status-inactive'
                          text='INACTIVE'
                        ></ChipDirective>
                      </ChipsDirective>
                    </ChipListComponent>
                  </div>
                </div>
                <div>
                  <span style={{ marginTop: '5px' }} className='col-md-3'>
                    Enabled
                  </span>
                  <div className='col-md-9'>
                    <ChipListComponent
                      id='chip-avatar-enabled'
                      ref={(g) => (this.chipsEnabled = g)}
                      selection='Single'
                      onClick={this.selectedEnabledText.bind(this)}
                    >
                      <ChipsDirective>
                        <ChipDirective
                          cssClass='chip-style-enabled-active'
                          text='ENABLE'
                        ></ChipDirective>
                        <ChipDirective
                          cssClass='chip-style-enabled-inactive'
                          text='DISABLE'
                        ></ChipDirective>
                      </ChipsDirective>
                    </ChipListComponent>
                  </div>
                </div>
              </div>
            </div>
            <div className='adaptor-section-center'>
              <div className='system-database'>
                <span>Source System</span>
                <div>
                  <ChipListComponent
                    id='chip-avatar'
                    selection='Single'
                    ref={(g) => (this.chipsSourceSystem = g)}
                    onClick={this.selectedSourceSystemText.bind(this)}
                  >
                    <ChipsDirective>
                      <ChipDirective
                        cssClass='chip-style'
                        text='PRONTO XI'
                        leadingIconCss='ProntoIcon'
                      ></ChipDirective>
                      <ChipDirective
                        cssClass='chip-style'
                        text='infor'
                        leadingIconCss='infoIcon'
                      ></ChipDirective>
                      <ChipDirective
                        cssClass='chip-style'
                        text='Microsoft Dynamics'
                        leadingIconCss='MicrosoftIcon'
                      ></ChipDirective>
                      <ChipDirective
                        cssClass='chip-style'
                        text='ORACLE'
                        leadingIconCss='OracleSourceIcon'
                      ></ChipDirective>
                    </ChipsDirective>
                  </ChipListComponent>
                </div>
                <div className='adaptor-database'>
                  <span>Database</span>
                  <ChipListComponent
                    id='chip-avatar-database'
                    selection='Single'
                    ref={(g) => (this.chipsDatabase = g)}
                    onClick={this.selectedDatabaseText.bind(this)}
                  >
                    <ChipsDirective>
                      <ChipDirective
                        cssClass='chip-style-database'
                        text='IBM'
                        leadingIconCss='IBMIcon'
                      ></ChipDirective>
                      <ChipDirective
                        cssClass='chip-style-database'
                        text='MySQL'
                        leadingIconCss='MySQLIcon'
                      ></ChipDirective>
                      <ChipDirective
                        cssClass='chip-style-database'
                        text='SQL Server'
                        leadingIconCss='SQLServerIcon'
                      ></ChipDirective>

                      <ChipDirective
                        cssClass='chip-style-database'
                        text='ORACLE'
                        leadingIconCss='ORACLEIcon'
                      ></ChipDirective>
                    </ChipsDirective>
                  </ChipListComponent>
                </div>
                <div className='adaptor-connection'>
                  <div>
                    <label>Connection Types</label>
                    <div className='adaptor-connection-types'>
                      <DropDownListComponent
                        id='source-adaptor-conn-type'
                        ref={(ct: DropDownListComponent) =>
                          (this.connectionType = ct)
                        }
                        placeholder='Connection Types'
                        value={this.state.ConnectionTypes}
                        fields={{ value: 'id', text: 'name' }}
                        dataSource={[
                          { id: 1, name: 'Windows Linked Server' },
                          { id: 2, name: 'ODBC' },
                          { id: 3, name: 'SQL' },
                          {
                            id: 4,
                            name: 'Application Public Integration Service (Api S)',
                          },
                        ]}
                        onChange={(e: any) => {
                          this.setState({ ConnectionTypes: e.value });
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <label>Connection Activate Date</label>
                    <div className='adaptor-activate-date'>
                      <DatePickerComponent
                        format='dd/MM/yyyy'
                        id='activateDate'
                        placeholder='Connection Activate Date'
                        value={this.state.ConnectionActivatedDate}
                        onChange={(e: any) => {
                          this.setState({ ConnectionActivatedDate: e.value });
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <label>Connection Disabled Date</label>
                    <div className='adaptor-disabled-date'>
                      <DatePickerComponent
                        format='dd/MM/yyyy'
                        id='disabledDate'
                        value={this.state.ConnectionDisabledDate}
                        onChange={(e: any) => {
                          this.setState({ ConnectionDisabledDate: e.value });
                        }}
                        placeholder='Connection Disabled Date'
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='divider'>
                <div className='divider-line'></div>
              </div>
              <div className='adaptor-file'>
                <label style={{ display: 'block' }}>Supporting Files</label>
                <UploaderComponent
                  autoUpload={false}
                  asyncSettings={this.path}
                />
              </div>
            </div>
          </div>
          <div className='container-sourceadaptor'>
            <label style={{ marginBottom: '5px' }}>
              Syncronisation Container
            </label>
            <GridComponent
              //onClick={this.gridOnFocus}
              dataSource={this.state.SyncContainerTempData}
              editSettings={this.editOptions}
              // toolbar={this.toolbarOptionsContainer}
              toolbarTemplate={this.templateGoToContainer.bind(this)}
              ref={(g: GridComponent) => (this.gridSync = g)}
              height='25vh'
              filterSettings={this.FilterOptions}
              allowFiltering={true}
              allowPaging={true}
              pageSettings={this.pageOptions}
              showColumnMenu={true}
              allowResizing={true}
              allowGrouping={true}
              toolbarClick={this.toolbarClick.bind(this)}
              //actionBegin={this.begin.bind(this)}
              gridLines='Both'
              created={this.gridSyncOncreated.bind(this)}
              queryCellInfo={this.cellRenderSyncContainer}
              //rowSelected={this.rowselect.bind(this)}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field=''
                  headerText='Details'
                  template={(args: any) => {
                    return (
                      <div>
                        <AiFillRightCircle
                          size={20}
                          onClick={this.gotoContainers.bind(this, args)}
                        />
                      </div>
                    );
                  }}
                />
                <ColumnDirective
                  field='container_id'
                  headerText='Container ID'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='container_name'
                  headerText='Container Name'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='adapter_name'
                  headerText='Adaptor Name'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='status'
                  headerText='Status'
                  textAlign='Left'
                  width={'40px'}
                />
                <ColumnDirective
                  field='enabled'
                  headerText='Enabled'
                  textAlign='Left'
                  width={'40px'}
                />
              </ColumnsDirective>
              <Inject
                services={[
                  Edit,
                  Toolbar,
                  Filter,
                  Page,
                  ColumnMenu,
                  Resize,
                  Search,
                  Group
                ]}
              />
            </GridComponent>
          </div>
        </div>
        <div className='control-pane-dialog'>
          <div
            id='targetElement'
            className='col-lg-12 defaultDialog dialog-target'
          >
            {this.state.hideDialogDeleteSourceAdaptor ? (
              <DialogComponent
                isModal={true}
                id='defaultDialogDelete'
                showCloseIcon={true}
                visible={this.state.hideDialogDeleteSourceAdaptor}
                header='Confirmation'
                width={200}
                height={'auto'}
                buttons={this.buttonForDelete}
                open={() => {
                  this.setState({ hideDialogDeleteSourceAdaptor: true });
                }}
                close={() => {
                  this.setState({ hideDialogDeleteSourceAdaptor: false });
                }}
              >
                <div className='container'>
                  <div className='row'>
                    {this.state.DeletedTextModal ? (
                      <span>{this.state.DeletedTextModal}</span>
                    ) : (
                      <span>Are you sure?</span>
                    )}
                  </div>
                </div>
              </DialogComponent>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
export default SourceAdaptor;
